import { IoMdAdd } from "react-icons/io";
import { Container, NewQuestionButton } from "./styles";
import Question from "./Question";
import { newQuestionPayload, SURVEY_FORM_FIELDS, SURVEY_QUESTION_FIELDS } from "../../../constants";

export default function QuestionsSection({
  values = {},
  onChangeValue = () => null,
}) {
  const handleAddNewQuestion = () => {
    const prevQuestions = Array.isArray(values[SURVEY_FORM_FIELDS.QUESTIONS])
      ? values[SURVEY_FORM_FIELDS.QUESTIONS]
      : [];

    const lastQuestion = prevQuestions[prevQuestions.length - 1];

    const newQuestionOrder = typeof lastQuestion === 'undefined' ? prevQuestions.length : lastQuestion.order + 1;

    const newQuestion = {
      ...newQuestionPayload,
      [SURVEY_QUESTION_FIELDS.KEY]: newQuestionOrder,
      [SURVEY_QUESTION_FIELDS.ORDER]: newQuestionOrder,
    };

    const newQuestions = [...prevQuestions, newQuestion];

    onChangeValue(SURVEY_FORM_FIELDS.QUESTIONS, newQuestions);
  };

  const questions = Array.isArray(values[SURVEY_FORM_FIELDS.QUESTIONS])
    ? values[SURVEY_FORM_FIELDS.QUESTIONS]
    : [];

  const handleChangeQuestion = (question) => {
    const prevQuestions = Array.isArray(values[SURVEY_FORM_FIELDS.QUESTIONS])
      ? values[SURVEY_FORM_FIELDS.QUESTIONS]
      : [];
    const currentQuestionIndex = prevQuestions.findIndex(
      (prevQuestion) =>
        prevQuestion[SURVEY_QUESTION_FIELDS.KEY] ===
        question[SURVEY_QUESTION_FIELDS.KEY]
    );

    const newQuestions = [...prevQuestions];

    if (currentQuestionIndex >= 0) {
      newQuestions[currentQuestionIndex] = question;
    } else {
      newQuestions.push(question);
    }

    onChangeValue(SURVEY_FORM_FIELDS.QUESTIONS, newQuestions);
  };

  const handleChangeQuestionOrder = (question, newOrder) => {
    const newQuestion = {
      ...question,
      [SURVEY_QUESTION_FIELDS.ORDER]: newOrder
    }

    const currentQuestionIndex = questions.findIndex(prevQuestion => prevQuestion[SURVEY_QUESTION_FIELDS.KEY] === question[SURVEY_QUESTION_FIELDS.KEY]);
    const nextQuestionIndex = questions.findIndex(prevQuestion => +prevQuestion[SURVEY_QUESTION_FIELDS.ORDER] === +newOrder);

    if(nextQuestionIndex >= 0) {
      const newNextQuestion = {
        ...questions[nextQuestionIndex],
        [SURVEY_QUESTION_FIELDS.ORDER]: question[SURVEY_QUESTION_FIELDS.ORDER]
      }

      const newQuestions = [...questions];

      newQuestions[currentQuestionIndex] = newQuestion;
      newQuestions[nextQuestionIndex] = newNextQuestion;

      onChangeValue(SURVEY_FORM_FIELDS.QUESTIONS, newQuestions);

      return;
    }

    handleChangeQuestion(newQuestion);
  }

  const handleDeleteQuestion = (question) => {
    const newQuestions = questions.filter(prevQuestion => prevQuestion[SURVEY_QUESTION_FIELDS.KEY] !== question[SURVEY_QUESTION_FIELDS.KEY]);

    onChangeValue(SURVEY_FORM_FIELDS.QUESTIONS, newQuestions);
  }

  return (
    <Container>
      {questions
        .sort(
          (questionA, questionB) =>
            (+questionA[SURVEY_QUESTION_FIELDS.ORDER] -
            +questionB[SURVEY_QUESTION_FIELDS.ORDER])
        )
        .map((question, index, questions) => {
          return (
            <Question
              key={question.key}
              isFirstQuestion={index === 0}
              isLastQuestion={index === (questions.length - 1)}
              question={question}
              onChangeQuestion={handleChangeQuestion}
              onChangeQuestionOrder={(newOrder) => handleChangeQuestionOrder(question, newOrder)}
              onDeleteQuestion={handleDeleteQuestion}
            />
          );
        })}
      <NewQuestionButton onClick={handleAddNewQuestion}>
        <IoMdAdd size="1.5em" />
        Criar nova questão
      </NewQuestionButton>
    </Container>
  );
}
